import React from 'react';
import { useSelector } from 'react-redux';
import selectors from 'state/selectors';
import { modalActionType } from 'utils/constants';
import PasswordModal from 'components/Modal/PasswordModal';
import ResetPassword from '../../../../components/Modal/ResetPassword';

const ModalsContent = () => {
  const actionType = useSelector(selectors.modal.getActionType);

  switch (actionType) {
    case modalActionType.USER_PASSWORD:
      return <PasswordModal />;
    case modalActionType.RESET_PASSWORD:
      return <ResetPassword />;
    default:
      return null;
  }
};

export default ModalsContent;
